<template>
<div>
    <base-header v-once pageName="영업활동계획" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
        <ul class="tab tab-fix">
            <li><button type="button" @click="bsnPlanList()">지국 영업활동계획</button></li>
            <li><button type="button" class="current">소속 조직원 계획</button></li>
        </ul>
        <div class="search head">
            <base-selectbox selectName="년도 선택"
                :default="searchYear"
                :only="false"
                v-on:selectSearch="year"
                :options="makeSelect(2021)"
            ></base-selectbox>

            <base-selectbox selectName="월 선택"
                :default="searchMonth+'월'"
                :only="false"
                v-on:selectSearch="month"
                :options="monthOptions"
            ></base-selectbox>

            <button type="button" class="selected" @click="searchList">조회</button>

            <input type="search" v-model="searchTxt" class="search" placeholder="이름, 사번을 입력하세요.">

            <base-selectbox selectName="조직원 선택"
                :valName="''"
                :default="''"
                v-on:selectSearch="selectPstn"
                :only="false"
                :options="orgOptnList"
            ></base-selectbox>
        </div>

        <div class="bsnsAcpln-list">
            <h5>{{searchYear}}년 {{searchMonth}}월</h5>
            <ul v-if="visibleList.length">
                <li v-for="orgItem in visibleList" v-bind:key="orgItem.userId">
                    <template v-if="!orgItem.sqno">
                        <p>
                            <em v-bind:class="pstnChk(orgItem.pstn)"></em>
                            <strong>{{orgItem.userName}}</strong>
                            <span>{{orgItem.userId}}</span>
                        </p>
                        <button type="button" @click="reqPlan(orgItem)">요청하기</button>
                    </template>
                    <template v-else>
                        <p @click="memberDetail(orgItem.sqno)">
                            <em v-bind:class="pstnChk(orgItem.pstn)"></em>
                            <strong>{{orgItem.userName}}</strong>
                            <span>{{orgItem.userId}}</span>
                        </p>
                        <template v-if="orgItem.stat === 'R'">
                            <button type="button" disabled>요청 중</button>
                        </template>
                        <template v-else>
                            <strong>{{orgItem.amtSum | numFormat}}만원</strong>
                        </template>
                    </template>
                </li>
            </ul>
            <div class="bsnsAcpln-list dataNone" v-else>
                검색된 영업활동 계획이 없습니다.
            </div>
        </div>
    </section>
</div>
</template>

<script>
// 영업활동계획(신규) - 지국장 "소속 조직원 계획" 탭.
// 조직도 조회(누가 내 소속인지)는 기존 백엔드 로직을 그대로 재사용했고, 실적 데이터만 새 테이블에서 가져온다.
// 기존 /mypage/headBsnPlnList (HeadBsnPlnList.vue) 는 전혀 건드리지 않는다.
export default {
  name: "BsnPlan2MemberList",

  data() {
    var now = new Date();
    return {
      searchYear: now.getFullYear() + '',
      searchMonth: ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1),
      searchTxt: '',
      searchPstn: '',
      list: [],

      // 기존 HeadBsnPlnList.vue 와 동일: "요청하기"가 열려있는 연월(구간 마감/시작일 기준)
      canReq: 'N',
      canReqYrmn: '',

      orgOptnList: [
        { text: '조직원 전체', value: '' },
        { text: '마스터', value: 'COGA2' },
        { text: '1급', value: 'COG03' },
        { text: '2급', value: 'COG04' },
        { text: '3급', value: 'COG05' },
        { text: '파트너', value: 'COG06' }
      ],
      monthOptions: [
        {text:'01월',value:'01'}, {text:'02월',value:'02'}, {text:'03월',value:'03'},
        {text:'04월',value:'04'}, {text:'05월',value:'05'}, {text:'06월',value:'06'},
        {text:'07월',value:'07'}, {text:'08월',value:'08'}, {text:'09월',value:'09'},
        {text:'10월',value:'10'}, {text:'11월',value:'11'}, {text:'12월',value:'12'}
      ]
    };
  },

  computed: {
    // 기존 HeadBsnPlnList.vue 와 동일한 두 가지 제약:
    // ① COG06(교육생/임시)은 목록에 안 보임
    // ② 지금 검색한 연월이 "요청하기 가능한 기간"이 아니면, 계획이 아직 없는(요청도 안 한) 사람은 안 보임
    visibleList: function() {
      var isReqWindow = this.canReqYrmn === (this.searchYear + this.searchMonth) && this.canReq === 'Y';
      return this.list.filter(function(orgItem) {
        if (orgItem.pstn === 'COG06') return false;
        if (!orgItem.sqno && !isReqWindow) return false;
        return true;
      });
    }
  },

  methods: {
    makeSelect: function(openYr) {
      var selectYear = new Date().getFullYear();
      var yearList = [];
      for (var i = 0; i <= selectYear - openYr; i++) {
        yearList.push({ text: selectYear - i, value: selectYear - i });
      }
      return yearList;
    },

    year: function(val) { this.searchYear = val; },
    month: function(val) { this.searchMonth = val; },
    selectPstn: function(val) { this.searchPstn = val; },

    searchList: function() {
      var that = this;
      var parameters = {
        searchYear: this.searchYear,
        searchMonth: this.searchMonth,
        searchTxt: this.searchTxt,
        searchPstn: this.searchPstn
      };
      this.$api.bsnPlan2
        .memberList(parameters)
        .then(function(data) {
          that.list = data.list || [];
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },

    reqPlan: function(orgItem) {
      if (confirm(orgItem.userName + "님에게 영업활동계획을 요청하시겠습니까?")) {
        var parameters = {
          targetUserId: orgItem.userId,
          targetUserName: orgItem.userName,
          planYr: this.searchYear,
          planMn: this.searchMonth
        };
        this.$api.bsnPlan2
          .reqPlan(parameters)
          .then(function(data) {
            if (data) {
              orgItem.sqno = data;
              orgItem.stat = 'R';
            }
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
      }
    },

    memberDetail: function(sqno) {
      this.$utils.nativeIf.outbound.newPage("/bsnplan2/memberDetail?sqno=" + sqno);
    },

    bsnPlanList: function() {
      this.$router.push('/bsnplan2/list');
    },

    pstnChk: function(pstn) {
      if (pstn == 'COG02') return 'epLv1';
      if (pstn == 'COGA2') return 'epLvA1';
      if (pstn == 'COG03') return 'epLv2';
      if (pstn == 'COG04') return 'epLv3';
      if (pstn == 'COG05') return 'epLv4';
      return '';
    }
  },

  filters: {
    numFormat: function(num) {
      if (num == 0) return 0;
      var n = num + '';
      var reg = /(^[+-]?\d+)(\d{3})/;
      while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');
      return n;
    }
  },

  created: function() {
    // 기존 HeadBsnPlnList.vue 와 동일한 "요청하기 가능 연월" 판단 —
    // sttEndInfo(KWKSOS 일정표 기반, TBL_SLOP_ACTV_PLAN 무관)를 그대로 재사용한다.
    var today = new Date();
    var thisYr = today.getFullYear() + '';
    var thisMn = ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1);
    var thisDy = ("00" + today.getDate()).slice(-2);

    var nextYr = '';
    var nextMn = '';
    if ((today.getMonth() + 2) > 12) {
      nextYr = (today.getFullYear() + 1) + '';
      nextMn = ((today.getMonth() - 10) < 10 ? '0' : '') + (today.getMonth() - 10);
    } else {
      nextYr = thisYr;
      nextMn = ((today.getMonth() + 2) < 10 ? '0' : '') + (today.getMonth() + 2);
    }

    var that = this;
    var parameters = {
      thisYrmn: thisYr + thisMn,
      nextYrmn: nextYr + nextMn
    };
    this.$api.mypage
      .sttEndInfo(parameters)
      .then(function(data) {
        if (data.firstSttDt) {
          if (data.firstSttDt > thisYr + thisMn + thisDy && data.fourthEndDt <= thisYr + thisMn + thisDy) {
            that.canReq = 'Y';
            that.canReqYrmn = nextYr + nextMn;
          }
        } else if (data.thisFirstSttDt && data.thisFirstSttDt >= thisYr + thisMn + thisDy) {
          that.canReq = 'Y';
          that.canReqYrmn = thisYr + thisMn;
        }

        if (data.firstEndDt && data.firstEndDt2 && data.firstEndDt <= thisYr + thisMn + thisDy && data.firstEndDt2 >= thisYr + thisMn + thisDy) {
          that.canReq = 'Y';
          that.canReqYrmn = thisYr + thisMn;
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });

    this.searchList();
  }
};
</script>
